import { Navigate } from 'react-router-dom'

import { FullPageLoader } from '@/components/loading-state'
import { useSessionStore } from '@/lib/auth/session-store'

/**
 * Bootstrap route (`/`) and the catch-all for unknown paths.
 *
 * The startup orchestrator (`features/auth/startup`) owns app-config, session
 * restore and the legal-status gate; this screen only routes guests to
 * onboarding and authenticated users to home. The brand splash is rendered by
 * the root layout so deep links get it too.
 */
export function BootstrapScreen() {
  const status = useSessionStore((state) => state.status)

  if (status === 'unknown') return <FullPageLoader />

  return (
    <Navigate
      to={status === 'authenticated' ? '/home' : '/onboarding'}
      replace
    />
  )
}
